import { render, staticRenderFns } from "./ViewInformation.vue?vue&type=template&id=1533c28a&"
import script from "./ViewInformation.vue?vue&type=script&lang=js&"
export * from "./ViewInformation.vue?vue&type=script&lang=js&"
import style0 from "./ViewInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports